import { Badge } from "@qivia/ui";
import { colors } from "@qivia/ui/src/styles/figmaColors";
import styled from "styled-components";
import { useTranslation } from "react-i18next";
import "../../../../i18n/i18n";

const cleanedColors = {
  backgroundColor: colors["colors/system/success/success_ultraLight"],
  textColor: colors["colors/system/success/success_dark"],
};

const uncleanedColors = {
  backgroundColor: colors["colors/system/error/error_ultraLight"],
  textColor: colors["colors/system/error/error_dark"],
};

const neutralColors = {
  backgroundColor: colors["colors/surfaces/background/background_level2"],
  textColor: colors["colors/text/darkGrey"],
};

export const CleaningTag = (props: { isCleaned: boolean }) => {
  const { isCleaned } = props;
  const { t } = useTranslation();
  const { backgroundColor, textColor } = isCleaned
    ? cleanedColors
    : uncleanedColors;

  return (
    <Badge
      text={t(`fleet.vehicleSessions.value.${isCleaned}`)}
      backgroundColor={backgroundColor}
      textColor={textColor}
    />
  );
};

export const CleaningCellTag = (props: { isCleaned: boolean }) => {
  const { isCleaned } = props;
  const { t } = useTranslation();
  const { backgroundColor, textColor } = isCleaned
    ? cleanedColors
    : neutralColors;

  return (
    <StyledCell>
      <Badge
        text={t(`fleet.vehicleSessions.value.${isCleaned}`)}
        backgroundColor={backgroundColor}
        textColor={textColor}
      />
    </StyledCell>
  );
};

const StyledCell = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
`;
